import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { reportError } from 'utils/error'
import { buildErrorMessage } from 'utils'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { useQuery } from 'react-query'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'

export interface BestPerformingPlatformPost {
  caption: string
  comments_count: number
  created_at: string
  engagement_rate: number
  external_integration: ExternalIntegration
  id: number
  image_description: string
  impressions: number
  like_count: number
  media_type: string
  media_url: string
  post_id: number
  timestamp: string
  topic: string
  total_interactions: number
  updated_at: string
}

interface Data {
  best_performing_platform_posts: BestPerformingPlatformPost[]
}

const fetchBestPerformingPosts = async ({ workspaceId }: { workspaceId: number }) => {
  const response = await sendToApi<Data>(`/w/${workspaceId}/best_performing_platform_posts`, {
    method: 'GET',
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    reportError('Failed to fetch best performing posts', {
      metaData: {
        response: response.data,
      },
    })
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useAllBestPerformingPlatformPosts = () => {
  const workspaceId = useCurrentWorkspaceId()

  return useQuery<Data, Error>(
    ['best_performing_platform_posts', workspaceId],
    () => fetchBestPerformingPosts({ workspaceId }),
    {
      enabled: !!workspaceId,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  )
}
